import { isEmail } from '@utils/validate-email'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { z } from 'zod'

export const cardholderFormSchema = z.object({
  cardholderNameEn: z.string().min(1, 'enterCardholderName'),
  email: z.string().refine(val => val === '' || isEmail(val), {
    message: 'invalidEmail',
  }),
  phoneCountryCode: z.string(),
  phoneNumber: z.string(),
}).refine(
  data => data.email || data.phoneNumber,
  {
    message: 'emailOrPhoneNumberRequired',
    path: ['email'],
  },
).refine(
  data => data.email || data.phoneNumber,
  {
    message: 'emailOrPhoneNumberRequired',
    path: ['phoneCountryCode'],
  },
).refine(
  (data) => {
    // 如果沒有填寫手機號碼，則不驗證
    if (!data.phoneNumber) return true
    // 如果有填寫手機號碼但沒有填寫國碼，驗證失敗
    if (!data.phoneCountryCode) return false
    // 組合完整的國際電話號碼格式 (e.g., +886912345678)
    const fullPhoneNumber = `+${data.phoneCountryCode}${data.phoneNumber}`
    // 驗證手機號碼格式
    return isValidPhoneNumber(fullPhoneNumber)
  },
  {
    message: 'invalidPhoneNumber',
    path: ['phoneCountryCode'],
  },
)

export type CardholderFormValues = z.infer<typeof cardholderFormSchema>
